export const CLEAR_SEARCH_STRING = 'search/CLEAR_SEARCH_STRING';
export const FETCH_SEARCH_RESULTS = 'search/FETCH_SEARCH_RESULTS';
export const FETCH_SEARCH_RESULTS_ERROR = 'search/FETCH_SEARCH_RESULTS_ERROR';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'search/FETCH_SEARCH_RESULTS_SUCCESS';
export const RESET_SEARCH = 'search/RESET_SEARCH';
export const SEARCH_TEXT_CHANGED = 'search/SEARCH_TEXT_CHANGED';
